import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportSearchKeywordsData } from "../../../../models/FacilityReportData";
import LocationKeywordsChart from "../../../FacilityDetailsComponents/LocationKeywordsChart";
import { EditableAISummary } from "../EditableAISummary";

interface ISearchKeywordsSectionProps {
  searchKeywords?: FacilityReportSearchKeywordsData;
  startDate?: string;
  endDate?: string;
  facilityReportId: string;
  isDownloading: boolean;
}

export const SearchKeywordsSection: React.FunctionComponent<
  ISearchKeywordsSectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const {
    searchKeywords,
    startDate,
    endDate,
    facilityReportId,
    isDownloading,
  } = props;

  if (!searchKeywords || !startDate || !endDate) {
    return null;
  }

  return (
    <div className="search-keywords-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-search-keywords-section"
      >
        <EditableAISummary
          title={t("searchKeywordsSection.title")}
          summary={searchKeywords.ai_summary}
          facilityReportId={facilityReportId}
          patchKey="search_keywords"
          isDownloading={isDownloading}
        />
        {!searchKeywords.location_keyword_data ? (
          <p className="no-data-message">{t("no_data")}</p>
        ) : (
          <LocationKeywordsChart
            data={[searchKeywords.location_keyword_data]}
            canSelectionMultiLocations={false}
            initDateRange={{
              fromDate: startDate,
              toDate: endDate,
            }}
            showDownloadButtons={false}
            chartContainerId="facility-report-details-search-keywords-chart"
          />
        )}
      </div>
    </div>
  );
};
